export const FILE_SCOPE_ACTIVITY = 'request_activity'

export const FILE_SCOPE_BUILDING = 'building'

export const FILE_SCOPE_BUILDING_GROUP = 'building_group'

export const FILE_SCOPE_EMAIL = 'mail'

export const FILE_SCOPE_CHAT = 'chat'

export const FILE_SCOPE_FLAT = 'flat'

export const FILE_SCOPE_THREAD = 'request_thread'

export const FILE_SCOPE_REQUEST = 'request'

export const FILE_SCOPE_REQUEST_CHAT = 'request_chat'

export const FILE_SCOPE_POST = 'post'

export const FILE_SCOPE_RENTAL_LISTING = 'rental_listing'

export const FILE_SCOPE_RENTAL_APPLICANT = 'rental_applicant'

export const FILE_SCOPE_TREE = 'tree'

export const FILE_SCOPE_USER = 'user'

export const FILE_MB_SIZE = 1024 * 1024

export const FILE_MAX_SIZE = 10 // mb

export const IMAGE_TYPES = [
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/pjpeg',
  'image/jpg',
  'image/x-windows-bmp',
  'image/x-icon',
]

export const IMAGE_THUMBNAIL_RESOLUTION = {
  72: 72,
  130: 130,
  170: 170,
  182: 182,
  340: 340,
  510: 510,
  512: 512,
  680: 680,
  698: 698,
  1020: 1020,
  1190: 1020,
  1360: 1360,
}

export const IMAGE_THUMBNAIL_RESOLUTIONS = {
  [IMAGE_THUMBNAIL_RESOLUTION[72]]: { height: 72, width: 72 },
  [IMAGE_THUMBNAIL_RESOLUTION[130]]: { height: 110, width: 130 },
  [IMAGE_THUMBNAIL_RESOLUTION[170]]: { height: 170, width: 170 },
  [IMAGE_THUMBNAIL_RESOLUTION[182]]: { height: 135, width: 182 },
  [IMAGE_THUMBNAIL_RESOLUTION[340]]: { height: 340, width: 340 },
  [IMAGE_THUMBNAIL_RESOLUTION[510]]: { height: 278, width: 510 },
  [IMAGE_THUMBNAIL_RESOLUTION[512]]: { height: 512, width: 512 },
  [IMAGE_THUMBNAIL_RESOLUTION[680]]: { height: 370, width: 680 },
  [IMAGE_THUMBNAIL_RESOLUTION[698]]: { height: 497, width: 698 },
  [IMAGE_THUMBNAIL_RESOLUTION[1020]]: { height: 555, width: 1020 },
  [IMAGE_THUMBNAIL_RESOLUTION[1190]]: { height: 648, width: 1190 },
  [IMAGE_THUMBNAIL_RESOLUTION[1360]]: { height: 740, width: 1360 },
}

export const PDF_TYPES = ['application/pdf']

export const VIDEO_TYPES = ['video/mp4']

export const DOC_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-word.template.macroEnabled.12',
]

export const XLS_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.ms-excel.addin.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
]

export const PPT_TYPES = [
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.ms-powerpoint.template.macroEnabled.12',
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
]

export const XML_TYPES = ['application/xml', 'text/xml', 'text/plain']

export const AUDIO_TYPES = ['audio/mpeg', 'audio/ogg']

export const AUDIO_TYPE = 'audio'

export const DOC_TYPE = 'doc'

export const PDF_TYPE = 'pdf'

export const PDF_TEMPLATE_TYPE = 'pdf_template' // custom type, is not existing in default types

export const IMAGE_TYPE = 'img'

export const PPT_TYPE = 'ppt'

export const XLS_TYPE = 'xls'

export const VIDEO_TYPE = 'video'

export const XML_TYPE = 'xml'

export const FILE_GIF_TYPE = 'image/gif'

export const FILE_JPEG_TYPE = 'image/jpeg'

export const FILE_PNG_TYPE = 'image/png'

export const FILE_IMAGE_TYPE_ALL = 'image/*'

export const FILE_EXTENSION_JPEG = '.jpeg'

export const FILE_EXTENSION_JPG = '.jpg'

export const FILE_EXTENSION_PNG = '.png'

export const FILE_FOLDER_TYPE = 7

export const FILE_TYPE_ALIASES = {
  [AUDIO_TYPE]: AUDIO_TYPES,
  [DOC_TYPE]: DOC_TYPES,
  [IMAGE_TYPE]: IMAGE_TYPES,
  [PDF_TYPE]: PDF_TYPES,
  [PPT_TYPE]: PPT_TYPES,
  [VIDEO_TYPE]: VIDEO_TYPES,
  [XLS_TYPE]: XLS_TYPES,
  [XML_TYPE]: XML_TYPES,
}

export const FILE_TYPE_TRANSLATIONS = {
  [AUDIO_TYPE]: 'File.AudioTypeKey',
  [DOC_TYPE]: 'File.DocTypeKey',
  [IMAGE_TYPE]: 'File.ImageTypeKey',
  [PDF_TYPE]: 'File.PdfTypeKey',
  [PPT_TYPE]: 'File.PptTypeKey',
  [VIDEO_TYPE]: 'File.VideoTypeKey',
  [XLS_TYPE]: 'File.XlsTypeKey',
  [XML_TYPE]: 'File.XmlTypeKey',
}

export const IMAGE_FIT_TYPES = {
  containAll: 'contain',
  containVertical: 'vertical',
  cover: 'cover',
}

// Characters that are not allowed in file names on Windows / macOS / Linux
export const FILE_NAME_FORBIDDEN_CHARS_REGEXP = /[<>:"/\\|?*]+/g

export const FILE_NAME_WHITESPACE_REGEXP = /\s+/g

// Common file systems limit a single file name to 255 characters
export const FILE_NAME_MAX_LENGTH = 255
